import React from 'react'

// const debug = "FieldTimeReported_PickerValueNotEmpty"
const debug = false

export default function FieldTimeReported_PickerValueNotEmpty(props:any) {

    const displayValue = props.field.getDisplayValue(props.value)

    const onReset = (e:any) => {
        e.stopPropagation()
        props.onChange(null)
    }

    debug && console.log(debug, 'render', displayValue, props.value)

    const iconClasses = Classes("icon m-l-7 m-r-5", props.field.icon, props.options?.iconClass)

    return (
        <div className  = "ui5-field-picker flex-row-left-center"
             onClick    = {props.onClick}
        >
            <div className={iconClasses}/>

            <div className="m-r-8 ui5-txt-less-important-small lh-20">{displayValue}</div>

            <div className  = "flex-row-center-center ui5-icon-close fs-10 m-r-6 p-0"
                 onClick    = {onReset}
            />

            {props.children}
        </div>
    )

}
